import React, { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

const ToolAppViewer = () => {
  const { toolName } = useParams();
  const location = useLocation();

  const iframeSrc = useMemo(() => {
    const safeToolName = encodeURIComponent(toolName || "");
    const toolPathPrefix = `/tool/${toolName || ""}`;
    const toolsPathPrefix = `/tools/${toolName || ""}`;
    const staticToolsPathPrefix = `/staticTools/${toolName || ""}`;
    let wildcardPath = location.pathname;

    if (wildcardPath.startsWith(staticToolsPathPrefix)) {
      wildcardPath = wildcardPath.slice(staticToolsPathPrefix.length);
    } else if (wildcardPath.startsWith(toolsPathPrefix)) {
      wildcardPath = wildcardPath.slice(toolsPathPrefix.length);
    } else if (wildcardPath.startsWith(toolPathPrefix)) {
      wildcardPath = wildcardPath.slice(toolPathPrefix.length);
    }

    const normalizedPath = wildcardPath.startsWith("/") ? wildcardPath : `/${wildcardPath}`;
    const suffix = normalizedPath === "/" ? "/" : normalizedPath;
    return `/staticTools/${safeToolName}${suffix}${location.search || ""}${location.hash || ""}`;
  }, [location.hash, location.pathname, location.search, toolName]);

  if (!toolName) {
    return (
      <div style={{ padding: 24, color: "#7f1d1d" }}>
        Invalid tool URL.
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: "100vh", background: "#fff" }}>
      <iframe
        title={`tool-app-${toolName}`}
        src={iframeSrc}
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
};

export default ToolAppViewer;
